var map = {
	"./1.jpg": 1486,
	"./10.jpg": 1487,
	"./2.jpg": 1488,
	"./3.jpg": 1489,
	"./4.jpg": 1490,
	"./5.jpg": 1491,
	"./6.jpg": 1492,
	"./7.jpg": 1493,
	"./8.jpg": 1494,
	"./9.jpg": 1495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1485;